<template>
  <div class="select-language">
    <v-expansion-panel
      outline
      box
      item-text="name"
      label="Language"
      :aria-label="messages.ariaSelectLangDropdown + messages.ariaSelectedLanguage + ' ' + newLanguageSelected.langName"
      :expand="checkExpand()"
      v-model="panel"
    >
      <v-expansion-panel-content
        :disabled="false"
        return-obj
        :expand="checkExpand()"
        :hide-actions="true"
      >
        <template v-slot:header>
          <div class="flex">
            <img
              role="presentation"
              :alt="selectedLanguage.langName + ' flag icon'"
              :src="selectedLanguage.img"
              class="flag-icon"
              :aria-hidden=true
            >
            <div class="selected-language-name fullLangName">{{selectedLanguage.langName}}</div>
            <div class="selected-language-name shortLangName" :aria-hidden=true>{{selectedLanguage.lang.toUpperCase()}}</div>
          </div>
        </template>
        <div class="realignDropDownLanguage">
        <v-btn-toggle
          v-for="(item, index) in languages"
          :key="index"
          v-model="newLanguageSelected"
          flat
          :disabled="false"
        >
          <v-btn
            :value="item"
            :disabled=false
            :aria-label="(selectedLanguage.langName === item.langName)? item.langName+' selected':item.langName"
          >
            <div class="flex">
              <img
                role="presentation"
                :alt="item.langName + ' flag icon'"
                :src="item.img"
                class="flag-icon"
                :aria-hidden=true
              >
              <div class="selected-language-name" >{{item.langName}}</div>
            </div>
          </v-btn>
        </v-btn-toggle>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LanguageDropdown',
  props: [
    'selectedLanguage',
    'languages'
  ],
  data: () => ({
    newLanguageSelected: {},
    panel: 1
  }),
  computed: {
    ...mapState([
      'messages'
    ])
  },
  watch: {
    newLanguageSelected (selectedLang) {
      if (selectedLang) { this.$emit('change-language', selectedLang) }
    },
    selectedLanguage (newLang, oldLang) {
      this.newLanguageSelected = this.selectedLanguage
      this.closePanel()
    }
  },
  mounted () {
    this.newLanguageSelected = this.selectedLanguage
  },
  methods: {
    checkExpand () {
      return this.expanded
    },
    closePanel () {
      this.panel = 1
    }
  }
}
</script>

<style lang="scss">
.select-language {
  position: absolute;
  top: 20px;
  right: 0;
  width: 203px;
  font-size: 14px;
  margin-right: 16px;
  z-index: 998;
  background-color: white;

  @at-root [dir="rtl"] & {
    right: auto;
    left: 0;
    margin-right: 0;
    margin-left: 16px;
  }
}

.flag-icon {
  height: 14px;
  width: 19px;
}

.select-language
  .v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 0;
}

.select-language .v-text-field--box .v-input__slot {
  border-radius: 0;
  min-height: 45px;
}

.select-language .v-btn__content {
  min-height: 22px;
}

.select-language .v-btn-toggle {
  width: 199px;
}
.select-language .v-btn {
  width: 199px;
  padding-left:20px;
  opacity:1;
  background-color: white !important;
  box-shadow:none;
  -webkit-box-shadow: none;
  max-height: 38px;
  margin:1px;
  border: none;
  text-transform: none;
}

.v-btn:not(.v-btn--depressed):not(.v-btn--flat){
   box-shadow:none;
  -webkit-box-shadow: none;
}

.select-language .v-btn-toggle:before {
  background-color: white !important;

}

.select-language .v-text-field .v-input__append-inner {
  margin-top: 9px;
}

.select-language .selected-language-name {
  margin-left: 8px;
  font-size: 14px;
  width: 125px;
  text-align: left;
  @at-root [dir="rtl"] & {
    margin-left: 0;
    margin-right: 8px;
    text-align: right;
  }
}
.language-option {
  margin-left: 8px;
  font-size: 14px;

  @at-root [dir="rtl"] & {
    margin-left: 0;
    margin-right: 8px;
  }
}

.fullLangName {
  display: inline;
}

.shortLangName {
  display: none;
}

.realignDropDownLanguage {
  position: relative;
}

@media only screen and (max-width: 600px) {
  .select-language {
    width: 70px;
  }
  .fullLangName {
    display: none;
  }
  .shortLangName {
     display: inline;
  }
  .realignDropDownLanguage {
    left: -130px;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .select-language .selected-language-name {
    margin-left: 2px;
  }
}
</style>
